import React, { useState, useEffect } from 'react';
import { geolocationService } from '../../../engine/utils/geolocation';

interface DebugInfoProps {
    fps: number;
    entityCount: number;
    level: number;
    score: number;
    lives: number;
    isVisible: boolean;
}

const DebugInfo: React.FC<DebugInfoProps> = ({
    fps,
    entityCount,
    level,
    score,
    lives,
    isVisible
}) => {
    const [countryInfo, setCountryInfo] = useState<string>('Detecting...');

    useEffect(() => {
        const detectCountry = async () => {
            try {
                await geolocationService.detectGermany();
                const countryCode = geolocationService.getCountryCode();
                setCountryInfo(countryCode || 'Unknown');
            } catch (error) {
                console.warn('Failed to detect country:', error);
                setCountryInfo('Unknown');
            }
        };

        detectCountry();
    }, []);

    if (!isVisible) return null;

    return (
        <div style={{
            position: 'absolute',
            top: '5px',
            left: '-240px',
            fontSize: '14px',
            fontFamily: 'monospace',
            background: 'linear-gradient(135deg, rgba(0,100,0,0.9) 0%, rgba(34,139,34,0.8) 50%, rgba(85,107,47,0.7) 100%)',
            padding: '15px',
            borderRadius: '10px',
            // border: '2px solid #32CD32',
            boxShadow: '0 8px 25px rgba(0,0,0,0.5), 0 0 15px rgba(50,205,50,0.3)',
            textAlign: 'left',
            minWidth: '180px',
            animation: 'debugGlow 2s ease-in-out infinite alternate'
        }}>
            <div style={{
                color: '#32CD32',
                fontWeight: 'bold',
                marginBottom: '10px',
                textAlign: 'center',
                fontSize: '16px',
                textShadow: '1px 1px 3px rgba(0,0,0,0.8)'
            }}>
                🔧 JUNGLE DEBUG
            </div>

            <div style={{
                color: '#F0F8FF',
                fontSize: '12px',
                lineHeight: '1.4'
            }}>
                <div style={{ marginBottom: '5px' }}>
                    ⚡ FPS: <span style={{ color: '#32CD32' }}>{fps.toFixed(1)}</span>
                </div>
                <div style={{ marginBottom: '5px' }}>
                    🏗️ Entities: <span style={{ color: '#32CD32' }}>{entityCount}</span>
                </div>
                <div style={{ marginBottom: '5px' }}>
                    🌴 Level: <span style={{ color: '#228B22' }}>{level}</span>
                </div>
                <div style={{ marginBottom: '5px' }}>
                    💎 Score: <span style={{ color: '#32CD32' }}>{score}</span>
                </div>
                <div style={{ marginBottom: '5px' }}>
                    ❤️ Lives: <span style={{ color: '#FF4500' }}>{lives}</span>
                </div>
                <div style={{ marginBottom: '5px' }}>
                    🌍 From: <span style={{ color: '#87CEEB' }}>{countryInfo}</span>
                </div>
            </div>

            <style>{`
                @keyframes debugGlow {
                    0% { box-shadow: 0 8px 25px rgba(0,0,0,0.5), 0 0 15px rgba(50,205,50,0.3); }
                    100% { box-shadow: 0 8px 25px rgba(0,0,0,0.5), 0 0 25px rgba(50,205,50,0.5); }
                }
            `}</style>
        </div>
    );
};

export default DebugInfo; 